<template>
  <div>
    <div class="position-relative" v-if="islogin">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew" style="background:url(/img/header_bg.jpg);">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">Ваш магазин
                  <span>управление вашим магазином</span>
                </h1>

              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->


      <div class="row " v-if="islogin==true">
        <div class="col-md-2">&nbsp;</div>
        <div class="col-md-10 ">

          <div>
            <base-button type="primary" v-if="user.isshop=1" @click="addItem()">
              Добавить товар
            </base-button>


          </div>
          <card>
            <div class="row" v-for="(row,row_index) in data" :key="data.last_id"
                 v-if="data.length>0">
              <div class="col-4">
                {{ row.title}}
              </div>
              <div class="col-4">
                {{ row.category.title }}
              </div>
              <div class="col-4">
                <button  @click="editItem(row_index)"
                         class="btn btn-warning">
                  Редактировать
                </button>
              </div>
            </div>
          </card>





        </div>

      </div>

    </div>


  </div>
</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import UserModel from "@/models/UserModel.js";


export default {
  name: "ManageItems",

  data() {
    var app = this;
    return {
      "user":{},
      "islogin":false,
      "modal_title": "Добавить товар",
      "iserror": false,
      "error_message": null,
      "newItem": {
        "new_option":{
          "title":"",
          "price":0,
        },
        "title":null,
        "currency":"RUB",
        "price":null,
        "islimited":false,
        "count":0,
        "photos":[],
        "options":[],
        "content_json":[],
        "category": null,
        'json': null,

      },
      "currencys_title":[],
      "type_currencys":[],
      "loaded_categorys": false,
      "categorys": null,
      'modals': {
        "add": null,
      },
      data: [],
      selected: null,
      defaultOpenedDetails: [],
      showDetailIcon: true,


    }
  },

  mounted: function () {
    var app=this;
    app.currencys_title=Vue.config.currencys_title;
    app.type_currencys=Vue.config.currencys;
    var user=UserModel.get();
    eventBus.$on('load_shop_my_user', rows => {
      app.data = rows.items;


    });
    console.log('super user');
    console.log(user);




    app.user=user;
    Api.loadShopCategorys(function(data){
      app.categorys=data.categorys;
      app.loaded_categorys=true;
      app.islogin = true;

    });
    Api.loadShopItems(true,function(rows){
      app.data = rows.items;
    });












  },
  methods: {
    editItem(index){
      var app=this;
      var newitem=this.data[index];
      var params = {

        type: "edititem",
        "categorys":app.categorys,
        isshop: true,
        newItem:newitem,
        json: newitem.content_json

      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    addItem() {
      var app=this;


      var params = {

        type: "additem",
        "categorys":app.categorys,
        isshop: true,
            "newItem": {
              "title":null,
              "currency":"RUB",
              "price":null,
              "islimited":false,
              "count":0,
              "photos":[],
              "options":[],
              "content_json":[],
              "category": null,
              'json': null,
              'enable':true,

            },
        modal_title: "Добавить товар",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Детальное описание товара",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }


    },

    deleteWork(parameter, par2) {
      console.log('id delete');
      console.log(parameter);
      console.log(par2);
    },
    clickRow(row) {
      console.log('the row is');
      console.log(row);
    },
    onSubmit(event) {


    },

  },

  components: {Modal}
};
</script>